/**
 * @typedef {{
 *   sourceLanguage: string,
 *   targetLanguage: string,
 *   sourceDocumentHash: string,
 *   model: string,
 * }} LetterTemplateTranslationMetadata
 */

/**
 * Callable-safe translation metadata for rich template writes and PDF preview.
 * Drops server-owned fields such as generatedAt and never forwards unknown keys.
 *
 * @param {unknown} translation
 * @returns {LetterTemplateTranslationMetadata | null}
 */
export function projectCallableLetterTemplateTranslationMetadata(translation) {
  if (translation == null) return null;
  if (typeof translation !== 'object' || Array.isArray(translation)) return null;

  const sourceLanguage = translation.sourceLanguage;
  const targetLanguage = translation.targetLanguage;
  const sourceDocumentHash = translation.sourceDocumentHash;
  const model = translation.model;

  if (
    typeof sourceLanguage !== 'string' ||
    typeof targetLanguage !== 'string' ||
    typeof sourceDocumentHash !== 'string' ||
    typeof model !== 'string'
  ) {
    return null;
  }

  return {
    sourceLanguage,
    targetLanguage,
    sourceDocumentHash,
    model,
  };
}
